import styled from "styled-components";

export const PoDetailsWrapper = styled.div`
  h6{
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-block:12px;
    color:${({theme}) => theme['table-text']};
}
/* .po-details-table{
  .ag-row-group.ag-row-group-expanded {
    background: #D950404A !important;
  }
} */
.po-details-table {
  background: #D950404A !important;
}
.po-detail-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    .header-info {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
    }

    .header-po-name {
      font-size: 18px;
      font-weight: 700;
      color: #1B2559;
      margin: 0;
      white-space: nowrap;
    }

    .header-vendor {
      font-size: 13px;
      color: #6B7280;
      font-weight: 500;
      white-space: nowrap;
    }

    .back-button {
      cursor: pointer;
      color: #6B7280;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 8px;
      transition: all 0.15s ease;
      &:hover {
        background: #F0F2F5;
        color: #1565D8;
      }
    }

    .header-divider {
      color: #E8ECF1;
      font-size: 16px;
    }

    .buttons-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 10px;
      margin-left: auto;
      flex-wrap: wrap;
      button {
        margin: 0;
      }
    }
}

.po-items-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 12px;

    .toolbar-search {
      margin-bottom: 0;
      input.form-control {
        height: 32px;
        padding-top: 4px;
        padding-bottom: 4px;
      }
      .form-group {
        margin-bottom: 0;
      }
    }

    .toolbar-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      button {
        white-space: nowrap;
      }
    }
}

.po-status-badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    &.badge-pending { background: rgba(255, 153, 0, 0.1); color: #FF9900; }
    &.badge-confirmed { background: rgba(21, 101, 216, 0.08); color: #1565D8; }
    &.badge-arrived { background: rgba(0, 156, 52, 0.08); color: #009C34; }
    &.badge-receiving { background: rgba(71, 181, 255, 0.1); color: #2196F3; }
    &.badge-processed { background: rgba(151, 71, 255, 0.08); color: #9747FF; }
    &.badge-deleted { background: rgba(217, 80, 64, 0.08); color: #D95040; }
}

/* Keep legacy .container-div for any other usage */
.container-div {
    display: flex;
    grid-gap: 24px;
    border: 1px solid ${({ theme }) => theme['secondary-color']};
    padding: 12px;
    border-radius: 8px;
    .items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
      label{
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      text-align: left;
      color:${({ theme }) => theme['body-text-color']};
      }
      p{
        margin: 0px;
        padding: 7px 12px;
        width: 100%;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        background: ${({ theme }) => theme['table-header-color']};
        border-radius: 2px;
        &.wear-house-name{
          width: 292px;
        }
      }
    }
    .buttons-wrapper{
    display: flex;
    justify-content: end;
    align-items: end;
    grid-gap: 12px;
    margin-left: auto;
      button{
        padding-block: 6px;
      }
    }
}
.box-row {
    margin-block: 16px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    width: 100%;
    gap: 16px;
    .ant-col {
      display: flex;
      flex-direction: column;
    }
    .sku-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      width: 100%;
      gap: 16px;
    }
    .sku-box {
      padding: 8px 14px;
      width: 100%;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      flex: 1;
      cursor: pointer;
      transition: all 0.15s ease;
      &.active-box {
        box-shadow: 0 0 0 2px currentColor;
      }
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      }
      h4 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0;
        line-height: 1.2;
        color: inherit;
      }
      p {
        color: #6B7280;
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        margin-bottom: 2px;
      }
      &.box-purple {
        background: rgba(104, 72, 186, 0.06);
        border: 1px solid rgba(104, 72, 186, 0.2);
        color: #6848BA;
      }
      &.box-blue {
        background: rgba(21, 101, 216, 0.06);
        border: 1px solid rgba(21, 101, 216, 0.2);
        color: #1565D8;
      }
      &.box-red {
        background: rgba(217, 80, 64, 0.06);
        border: 1px solid rgba(217, 80, 64, 0.2);
        color: #D95040;
      }
      &.box-yellow {
        background: rgba(242, 189, 66, 0.06);
        border: 1px solid rgba(242, 189, 66, 0.2);
        color: #D4A017;
      }
      &.box-green {
        background: rgba(88, 165, 93, 0.06);
        border: 1px solid rgba(88, 165, 93, 0.2);
        color: #58A55D;
      }
      &.box-orange {
        background: rgba(255, 153, 0, 0.06);
        border: 1px solid rgba(255, 153, 0, 0.2);
        color: #FF9900;
      }
    }
  }  
  .search-bar{
    width: 100%;
    max-width: 396px;
    input {
    max-width: 396px;
    padding-right: 32px;
    width: 100%;
}
  }
  .ag-header-cell.ag-focus-managed {
    display: flex;
    flex-direction: row-reverse;
}
.card-wrapper.gap-1 img {
    width: 14px;
}
  .card-wrapper {
    display: flex;
    grid-gap: 8px;
    .prod-image{
      min-width: 36px;
    }
    img{
      width: 36px;
      object-fit: contain;
      max-width:36px;
      max-height: 36px;
      height:auto;
   
    }
  .two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
    height: 34px;
}
  }
  .title-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    span{
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
  }
  .upc-code{
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: ${({ theme }) => theme['body-text-color']};
    
  }
}
.container-box {
  border: 1px solid ${({ theme }) => theme['border-color']};
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  .items {
    display: grid;
    grid-template-columns: 2fr 1fr;
    justify-content: space-between;
    &:not(:last-child){
      border-bottom: 1px solid ${({ theme }) => theme['border-color']};
    }
    span{
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      text-align: left;
      padding: 7px 12px;
      color: ${({ theme }) => theme['label-color-new']};
      &:nth-child(2){
        border-left: 1px solid ${({ theme }) => theme['border-color']};
      }
    }
}
}
.edit-able-data{
  display: flex;
  align-items: center;
  grid-gap: 4px;
  div{
    margin: 0;
  }
  svg{
    color:${({ theme }) => theme['primary-color']};
    cursor: pointer;
    font-size: 14px;
    &.increase-font{
      font-size: 20px;
    }
  }
  &.not-edit{
    div{
      width: 100%;

    }
    span{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    svg {
    color: #1565D8;
    cursor: pointer;
    font-size: 14px;
    display: block;
    width: 30px;
}
  }
}
.delete-icon{
  color: ${({ theme }) => theme['danger-hover']};
  font-size: 16px;
  cursor: pointer;
}
span.ag-cell-wrapper.ag-cell-expandable.ag-row-group {
    padding: 0px;
    height: 27px;
    min-height: 27px;
}
.ag-cell-wrapper {
      display: flex;
      flex-direction: row-reverse;
}

.delete-modal-wrapper{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    margin-bottom: 12px;
  }
  h3{
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    color: ${({ theme }) => theme['headingColor']};
    margin: 0;
    margin-bottom: 4px;
  }
  p{
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    color:${({ theme }) => theme['body-text-color']};
    margin: 0;
  }
}
.items-menu{
  display: flex;
  flex-direction: column;
  padding-block: 8px;
  span{
    cursor: pointer;
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color:${({ theme }) => theme['table-text']};
    padding: 4px 12px;
    &:hover{
      background-color: ${({ theme }) => theme['table-header-color']};
    }
  }
}
`;

export const InnerTableWrapper = styled.div`
*{
  font-family: "Titillium Web", sans-serif;
}
.po-details-wrapper-table-details .ag-body-viewport.ag-row-no-animation.ag-layout-auto-height.ag-selectable {
    min-height: ${({seller_skus}) => seller_skus.length <= 2 ? '100px' : 'auto'};
    max-height: ${({seller_skus}) => seller_skus.length <= 2 ? '100px' : '300px'};
    overflow: auto;
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height.ag-cell-value {
    border-right: 1px solid ${({ theme }) => theme['border-color']};
}
button{
  margin: auto;
  margin-block: 24px;
}
 .ag-header-cell{
  &::after {
    background-color: #E6E6E6;
    border-right: none;
    height: 100px;
    top: 0;
}
 }
.not-gated-icon-wrapper {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    span.bag-icon-gated {
    background: #009C34;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding: 1px 8px;
    color: #fff;
    border-radius: 2px;
    user-select: none;
    &.gated-error{
        color: red;
        background-color: transparent;
        font-weight: 600;
    }
    &.new-gated {
        background: #D95040;
    }
}
svg {
    color: #1565D8;
    cursor: pointer;
    font-size: 16px;
}
}

`
export const AddProductManualModalWrapper = styled.div`
.header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
    height: fit-content;
    span {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color:${({ theme }) => theme['primary-color']};
}
}
footer{
  display: flex;
align-items: center;
justify-content: end;
margin-top: 24px;
grid-gap: 16px;
}
`;

export const StepDataWrapper = styled.div`
.box-wrapper{
  border: 1px solid ${({ theme }) => theme['border-color']};;
  border-radius: 8px;
  margin-top: 24px;
header{
  background-color: ${({ theme }) => theme['table-header-color']};
  padding: 12px 16px;
  border-top-right-radius: 8px;
border-top-left-radius: 8px;
  h6{
font-size: 12px;
font-weight: 600;
line-height: 14px;
text-align: left;
margin: 0;

  }
}
.body-wrapper{
  padding: 24px 16px;
  .form-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    align-items: flex-end;
    grid-gap: 16px;
    & > div{
      margin: 0;
    }
    .inputs {
    input{
      height: 34px;
    }
}
.select2-container.add-product-manual-wrapper{
  margin: 0;
}
.select2-selection__control.css-13cymwt-control {
    height: auto;
    min-height: auto;
    max-height: 100% !important;
}
}
}

}
.box-items-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(168px, 1fr));
    grid-gap: 32px 12px;
    .add-product-manual-wrapper{
      margin: 0;
    }
    .value{
      display: flex;
      flex-direction: column;
      grid-row-gap: 8px;
      margin-top: 8px;
      p{
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      text-align: left;
      margin: 0;
      }
    }
}
.box-container{
  border: 1px solid ${({ theme }) => theme['border-color']};
  border-radius: 4px;
  .header-ui-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 2fr;
      &.new-header{
        grid-template-columns: 1fr 1fr 2fr;
      }
      span{
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color: #808183;
        &:not(:last-child) {
          border-right: 1px solid ${({ theme }) => theme['border-color']};
        }
      }
  }
  .scroll-able-content {
    min-height: 200px;
    overflow: auto;
    max-height: 350px;
  .body-boxes{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr;
    &.new-content{
        grid-template-columns: 1fr 1fr 1fr 2fr;
        &:last-child{
          border-bottom: 1px solid ${({ theme }) => theme['border-color']};
        }
      }
    span{
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-align: left;
        color: ${({ theme }) => theme['table-text']};
        display: flex;
        align-items: center;
        grid-gap: 4px;
        border-top: 1px solid ${({ theme }) => theme['border-color']};
        &:not(:last-child) {
          border-right: 1px solid ${({ theme }) => theme['border-color']};
        }
        &:last-child{
          white-space: nowrap;     
          overflow: hidden;        
          text-overflow: ellipsis;
          display: inline-block;
        }
        img{    
          position: relative;
          top: -1px;
          padding-right: 4px;}
  }
}
  .no-errors-message {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-size: 16px;
    color: #555;
    text-align: center;
  }}
}
.congratulations-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    grid-row-gap: 14px;
    h1 {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  margin: 0px !important;
  color: ${({theme}) => theme['label-color-new']};
}
p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    max-width: 333px;
    margin: 0;
    color: #5D5D5D;
}
button {
    max-width: 260px;
    width: 100%;
}
}
`;

export const DrawerWrapperUI = styled.div`
padding: 24px;
&.modal-ui-parent-wrapper{
  padding:0;
}
p.no-data-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
}
.modal-box-container {
  .select2-container {
    margin: 0px !important;
}
h6{
  font-size: 18px;
  line-height: 30px; 
  font-weight: 600; 
  color:#1565D8;
}
div{
  margin: 0px !important;
}
.select2-container .select2-selection__control {
    border: 1px solid #CFD8DC;
    max-height: 37px;
    min-height: 37px;
}
div#react-select-2-placeholder {
    position: relative;
    top: 0px;
}
}
header{
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  .left-content {
    display: flex;
    align-items: center;
    grid-gap: 4px;
    img {
    cursor: pointer;
}
h6 {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    color:#1565D8;
}
}
.right-content {
    display: flex;
    align-items: center;
    grid-gap: 16px;
}
}
.card-wrapper {
    display: flex;
  .two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
    height: 34px;
}
  }
  .title-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    span{
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    color: ${({ theme }) => theme['table-text']};
  }
  .upc-code{
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    color: ${({ theme }) => theme['body-text-color']};
    
  }
}
.ag-header-cell{
  &::after {
    background-color: #E6E6E6;
    border-right: none;
    height: 100%;
    top: 0;
}
}
.ag-cell.ag-cell-not-inline-editing.ag-cell-normal-height {
    border-right: 1px solid ${({ theme }) => theme['border-color']} !important;
}
.ag-selection-checkbox {
    margin-right: 6px !important;
}
.ag-labeled.ag-label-align-right.ag-checkbox.ag-input-field.ag-header-select-all {
    margin-right: 8px !important;
    margin-left: 0px;
}
.card-items {
    border: 1px solid ${({theme}) =>theme['border-color']};
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    border-radius: 4px;
    padding: 12px;
    h6 {
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    text-align: left;
    margin: 0;
    color: ${({theme}) =>theme['body-text-color']};
}
.title-wrapper {
    display: grid !important;
    grid-template-columns: 3fr 2fr 1fr !important;
    align-items: flex-start;
    .name-img {
    display: flex;
    align-items: center;
    p {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    width: 263px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}
}
.upc-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 6px;
    p {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 0;
    color: ${({theme}) =>theme['table-text']};

}
a {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    text-decoration: none;
    color: ${({theme}) =>theme['primary']};
    &:hover{
      text-decoration: underline;
      color: ${({theme}) =>theme['primary']};
      cursor: pointer;
    }
}
}
}
.icon {
    margin-left: auto;
    border: 1px solid ${({theme}) =>theme['border-color']};
    padding: 0px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    cursor: pointer;
    svg {
    font-size: 16px;
    color:${({theme}) =>theme['danger-hover']};
}
}
}
.inputs-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr;
    grid-gap: 12px;
    margin-top: 16px;
}
.card-items-wrapper {
    height: calc(100vh - 13vh);
    overflow: auto;
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
}
`;
